import { Box, Chip, Button, Skeleton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { rem } from "assets/js/common";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import { Link, useHistory } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";

const useStyles = makeStyles((theme) => ({
  recommend: {
    // "& .recommend-item": {
    //   position: "relative",
    //   width: rem(315),
    //   // "&:last-of-type": {
    //   //   paddingBottom: rem(10),
    //   // },
    //   "& img": {
    //     borderRadius: rem(10),
    //     width: "100%",
    //   },
    //   "& .tit": {
    //     paddingTop: rem(20),
    //     fontWeight: 700,
    //   },
    //   "& .MuiChip-root": {
    //     position: "absolute",
    //     top: rem(45),
    //     left: rem(45),
    //   },
    // },
    "& .recommend-wrap": {
      padding: `${rem(30)} 0 ${rem(73)}`,
      "& h3": {
        fontSize: rem(20),
        fontWeight: 800,
        lineHeight: rem(26),
        margin: `0  0 ${rem(27)} ${rem(30)}`,
      },
      "& .recommend-items": {
        position: "relative",
        overflowX: "auto",
        overflowY: "hidden",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        "& .mySwiper": {
          paddingBottom: 0,
          "& .swiper-wrapper > .swiper-slide": {
            // width: rem(345),
            width: "85%",
            "&:first-child": {
              marginLeft: rem(15),
            }
          },
        },
        "& .recommend-item": {
          width: "100%",
          marginLeft: rem(15),
          "& img": {
            width: "100%",
          },
          "& .tit": {
            fontWeight: 700,
            marginTop: rem(30),
            lineHeight: rem(20),
            "& p": {},
          },
        },
      },
    },
    "& .btn-total": {
      "& button": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        "&:before": {
          content: "''",
          width: rem(20),
          height: rem(20),
          backgroundImage: `url(${
            process.env.PUBLIC_URL
          }/images/icon/arrow-circle.svg)`,
          backgroundSize: `${rem(20)} ${rem(20)}`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        },
        "& span": {
          fontSize: rem(14),
          color: theme.palette.primary.main,
          fontWeight: 700,
          lineHeight: rem(22),
          marginTop: rem(7),
        },
      },
    },
  },
}));

export default function Recommend(props) {
  const classes = useStyles();
  const { data, loading } = useSelector((state) => state.home);
  const history = useHistory();
  const [recommendProductList, setRecommendProductList] = useState([]);

  useEffect(() => {
    if (data.recommendProductList)
      setRecommendProductList(data.recommendProductList.list);
  }, [data]);

  if (loading)
    return (
      <div className={classes.recommend}>
        <Box className="recommend-wrap">
          <h3>
            <Skeleton variant="rectangular" width={120} height={22} />
          </h3>
          <div className="recommend-items">
            <Swiper
              spaceBetween={15}
              slidesPerView={1.1}
              // centeredSlides={true}
              className="mySwiper"
            >
              {[...Array(3)].map((item, i) => (
                <SwiperSlide key={`reco-skel-${i}`}>
                  <div className="recommend-item">
                    <Skeleton
                      variant="rectangular"
                      width={"100%"}
                      height={176}
                    />
                    <div className="tit">
                      <Skeleton
                        variant="rectangular"
                        width={140}
                        height={16}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Box>
      </div>
    );

  return (
    <>
      {recommendProductList.length > 0 && (
        <div className={classes.recommend}>
          <Box className="recommend-wrap">
            <h3>{data.recommendProductTitle}</h3>
            <div className="recommend-items">
              <Swiper
                spaceBetween={15}
                slidesPerView="auto"
                // slidesOffsetAfter={130}
                className="mySwiper"
                // centeredSlides={true}
              >
                {recommendProductList.map((item, i) => (
                  <SwiperSlide key={`recommend-${i}`}>
                    <div
                      className="recommend-item"
                      onClick={() => {
                        history.push({
                          pathname: `/recommend-item/detail/${item.seq}`,
                          props: { seq: item.seq },
                        });
                      }}
                    >
                      <LazyCDNImage
                        cdnUrl={item.imgUrl}
                        style={{
                          height: rem(176),
                          borderRadius: "10px",
                        }}
                      />
                      <div
                        className="tit"
                        dangerouslySetInnerHTML={{
                          __html: item.ttl ? item.ttl : "-",
                        }}
                      />
                    </div>
                  </SwiperSlide>
                ))}
                <SwiperSlide
                  className="btn-total"
                  style={{ width: "auto", padding: "20% 15px 0 5px" }}
                >
                  <Button
                    onClick={() => {
                      history.push("/recommend-item");
                    }}
                  >
                    <span>전체보기</span>
                  </Button>
                </SwiperSlide>
              </Swiper>
            </div>
          </Box>
        </div>
      )}
    </>
  );
}
